import React, { useState } from 'react';
import NavLinkInterceptor from './NavLinkInterceptor';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header>
      <div className="container header-container">
        <div className="logo-container">
          <NavLinkInterceptor to="/">
            <img src="/graphics/Slogan transparent.png" alt="SpitFire Logo" className="logo" />
          </NavLinkInterceptor>
        </div>
        
        {/* Hamburger Menu Button (visible only on mobile) */}
        <div className="hamburger-menu" onClick={toggleMenu}>
          <div className={`hamburger-bar ${isMenuOpen ? 'open' : ''}`}></div>
          <div className={`hamburger-bar ${isMenuOpen ? 'open' : ''}`}></div>
          <div className={`hamburger-bar ${isMenuOpen ? 'open' : ''}`}></div>
        </div>
        
        {/* Navigation Menu */}
        <nav className={isMenuOpen ? 'open' : ''}>
          <ul>
            <li>
              <NavLinkInterceptor to="/home" end onClick={() => setIsMenuOpen(false)}>
                Home
              </NavLinkInterceptor>
            </li>
            <li>
              <NavLinkInterceptor to="/gallery" onClick={() => setIsMenuOpen(false)}>
                Gallery
              </NavLinkInterceptor>
            </li>
            <li>
              <NavLinkInterceptor to="/reviews" onClick={() => setIsMenuOpen(false)}>
                Reviews
              </NavLinkInterceptor>
            </li>
            <li>
              <NavLinkInterceptor to="/contact" onClick={() => setIsMenuOpen(false)}>
                Contact Us
              </NavLinkInterceptor>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;